import Feedback from './Feedback';
import FeedbackWithEditableBtn from './FeedbackWithEditableBtn';

export default Feedback;
export { FeedbackWithEditableBtn };
